import { DocInfo } from './doc-info.model';

export class DocsInFact {
  factId: string;
  docId: string;
  caseId: string;
  pageNumber: number;

  doc?: DocInfo;
}